var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.area && _vm.owner)?_c('span',{staticClass:"area-cell",style:({'background-color':_vm.backgroundColor})},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.owner.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }